import(/* webpackMode: "eager" */ "/app/app/indicators/investigator/networks/page.jsx");
